export class Maintenance {
  public _id: string
  public created: Date;
  public finished: boolean;
  public customer: any;
  public user: any;
  public machinemaintenances: any[];
  public workhours: string;
  public travelhours: string;
  public distance: string;
  public name: string;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/models/maintenance.model.ts